exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".noResultContainer___1VVGr {\n  padding: 1rem;\n  text-align: center;\n}\n.noResultCol___3nNeX {\n  margin-top: 0.5rem;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/causefundraisernodeweb-ci-release/public/js/redesignComponents/noSearchResult/noSearchResults.less"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB","file":"noSearchResults.less","sourcesContent":[".noResultContainer {\n  padding: 1rem;\n  text-align: center;\n}\n.noResultCol {\n  margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"noResultContainer": "noResultContainer___1VVGr",
	"noResultCol": "noResultCol___3nNeX"
};